var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38461 11.5386L7.38461 8.30781",
    stroke: "#8A8A8A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6154 11.5386L10.6154 8.30781",
    stroke: "#8A8A8A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.25H2.25C2.48217 5.25 2.59825 5.25 2.69603 5.25963C3.64559 5.35315 4.39685 6.10441 4.49037 7.05397C4.5 7.15175 4.5 7.26783 4.5 7.5V11C4.5 12.8856 4.5 13.8284 5.08579 14.4142C5.67157 15 6.61438 15 8.5 15H9.5C11.3856 15 12.3284 15 12.9142 14.4142C13.5 13.8284 13.5 12.8856 13.5 11V7.5C13.5 7.26783 13.5 7.15175 13.5096 7.05397C13.6032 6.10441 14.3544 5.35315 15.304 5.25963C15.4017 5.25 15.5178 5.25 15.75 5.25Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99386 2.99178C7.11219 2.79551 7.37294 2.62207 7.73566 2.49837C8.09838 2.37467 8.54281 2.30762 9.00001 2.30762C9.45721 2.30762 9.90164 2.37467 10.2644 2.49837C10.6271 2.62207 10.8878 2.79551 11.0062 2.99178",
    stroke: "#8A8A8A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGray);
export default __webpack_public_path__ + "static/media/trash-gray.a214dff6259e8514b847dfd3dca85bf3.svg";
export { ForwardRef as ReactComponent };